import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-polylinedecorator";
import L from "leaflet";

function PolylineArrorw({ polyline = null, isView = true, isArrowPolyyline, color = "#eb6434", mapPositionsData }) {
  const map = useMap();

  const patterns = [
    {
      repeat: 100,
      symbol: L.Symbol.arrowHead({
        pixelSize: 13,
        polygon: false,
        pathOptions: { stroke: true, color: color },
      }),
    },
  ];

  useEffect(() => {
    if (!map) return;

    map.eachLayer((e) => {
      if (e.options.isArrowPolyyline !== undefined && e.options.isArrowPolyyline === isArrowPolyyline) {
        map.removeLayer(e);
      }
    });

    if (isView) {
      if (polyline === null) {
        polyline = mapPositionsData.map((position) => {
          return [position.location.lat, position.location.long];
        });
      }

      L.polylineDecorator(polyline, {
        patterns,
        isArrowPolyyline,
      }).addTo(map);
    }
  }, [map]);

  return null;
}

export default React.memo(PolylineArrorw);
